import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { ShowNewsComponent } from './show-news/show-news.component';
import { StartComponent } from './start/start.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ShowFaqComponent } from './show-faq/show-faq.component';
import { ShowSurveyComponent } from './show-survey/show-survey.component';
import { LaunchTogetherComponent } from './launch-together/launch-together.component';

const routes: Routes = [
  { path: '', component: StartComponent },
  { path: 'launch-together', component: LaunchTogetherComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'news/:newsId', component: ShowNewsComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'faq/:faqId', component: ShowFaqComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'survey/:surveyId', component: ShowSurveyComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '*', redirectTo: '' },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule { }
